import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=72cea4ce&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=72cea4ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cea4ce",
  null
  
)

export default component.exports